<template>
  <div :class="['bottom-switch',centerStyle?centerStyle:'']">
    <div class="bottom-content swiper-container"
         :class="[blockData.floorSlideshow=='on'?'slide':'','bottom-content'+ swiperInd]">
      <ul :style="{width:`${blockCenterList.length*272 - 20}px`}"
          v-if="tabActiveType=='center'"
          class="clearfix swiper-wrapper">
        <li class="fl swiper-slide"
            v-for="(ite,ind) in blockCenterList"
            @contextmenu="setContentId(ite)"
            @touchstart="touchstarts(ite)"
            @touchmove="touchmoves()"
            @touchend="touchends()"
            @click.stop="$emit('emitHandleDetail',ite)"
            :key="ind">
          <a href="javascript:;">
            <ZImage :value="ite.pictures&&ite.pictures[0]?ite.pictures[0]:''"
                    :error-src="require('../../assets/image/images/default_media.png')" />
            <div class="li_hover"
                 @click.stop="$emit('emitHandleDetail',ite,'newDetail')">
              <p class="li_hover_title">
                {{ite.name?ite.name:''}}
              </p>
              <!-- <div class="img_right" @click.stop="$emit('emitChangeFlowTab',(ite,{refesh:false,activeTab:0,tabType:'center'}))"></div> -->
              <div class="li_hover_conter">
                <div class="label-box"
                     v-if="ite.others">
                  <div v-show="tag.standardName != '产品标识' && tag.standardData"
                       class="label-set"
                       v-for="(tag,tin) in ite.tags"
                       :key="tin">
                    <span>{{tag.standardName?tag.standardName+'：':''}}</span>{{allPrice(tag.standardEnName) ? formatPrice(tag.standardData) : tag.standardData}}
                  </div>
                </div>
                <div v-else
                     class="no-data white"></div>
              </div>
            </div>
          </a>
        </li>
      </ul>
      <ul :style="{width:`${flowNewList.length*238}px`}"
          class="clearfix swiper-wrapper"
          v-if="flowStep==1&&tabActiveType!='center'||flowStep==2&&tabActiveType!='center'">
        <li class="fl swiper-slide"
            v-for="(ite,ind) in flowNewList"
            @contextmenu="setProfessionId(ite)"
            @touchstart="touchstarts(ite)"
            @touchmove="touchmoves()"
            @touchend="touchends()"
            @click.stop="$emit('emitHandleDetail',ite)"
            :key="ind">
          <a href="javascript:;">
            <ZImage :value="require('../../assets/image/images/default_media.png')" />
            <div class="li_hover"
                 @click.stop="$emit('emitHandleDetail',ite,'newDetail')">
              <p class="li_hover_title">
                {{ite.name?ite.name:ite.appName}}
              </p>
              <!-- <div class="img_right" @click.stop="handleNextFlow(ite)"></div> -->
              <div class="li_hover_conter">
                <div class="label-box"
                     v-if="ite.applist&&ite.applist.length">
                  <div v-show="tag.appName != '产品标识'"
                       class="label-set"
                       v-for="(tag,tin) in ite.applist"
                       :key="tin">
                    <span>{{tag.appName?tag.appName:tag.name}}</span>
                  </div>
                </div>
                <div class="label-box"
                     v-else-if="ite.appList&&ite.appList.length">
                  <div v-show="tag.name != '产品标识'"
                       class="label-set"
                       v-for="(tag,tin) in ite.appList"
                       :key="tin">
                    <span>{{tag.name}}</span>
                  </div>
                </div>
                <div v-else
                     class="no-data white"></div>
              </div>
            </div>
          </a>
        </li>
      </ul>
      <ul v-if="listData.length&&flowStep==4&&tabActiveType!='center'"
          class="clearfix swiper-wrapper">
        <li class="fl swiper-slide"
            v-for="(ite,ind) in listData"
            @contextmenu.stop.prevent="ite.others.length?$emit('emitContextMenuItem',ind,$event):''"
            @touchstart="touchstarts(ind)"
            @touchmove="touchmoves()"
            @touchend="touchends()"
            @click.stop="$emit('emitHandleDetail',ite)"
            :key="ind">
          <div :class="[{'rightP':true,'rightSeckill':ite.discountTypes=='seckill','rightChange':ite.discountTypes=='change','rightSpell':ite.discountTypes=='spell','rightGive':ite.discountTypes=='give','rightMemberLevel':$store.state.memberLevel&&items[getMemberLevel($store.state.memberLevel).memberLevel]}]"
               v-if="(ite.discountTypes&& ite.endTime || $store.state.memberLevel&&items[getMemberLevel($store.state.memberLevel).memberLevel]&&items.memberEndTime) && seckillShow">
            <div class="rightContent">
              <span v-if="$store.state.memberLevel">{{getMemberLevel($store.state.memberLevel).name}}：￥<span style="fontSize:16px;">{{items[getMemberLevel($store.state.memberLevel).memberLevel]}}</span></span>
              <span v-if="ite.discountTypes=='seckill'">秒杀特惠：￥<span style="fontSize:16px;">{{ite.priceType}}</span></span>
              <span v-if="ite.discountTypes=='change'">换购特惠：￥<span style="fontSize:16px;">{{ite.changeData}}</span></span>
              <!-- 没件有赠 -->
              <span v-if="ite.discountTypes=='spell'&&ite.spellText.indexOf('件')==-1&&ite.spellData.indexOf('赠')>-1">满￥<span style="fontSize:16px;">{{ite.spellText}}</span>：赠<span style="fontSize:16px;">{{ite.spellData.match(/\d+(\.\d+)?/g)[0]}}</span></span>
              <!-- 有件没赠 -->
              <span v-if="ite.discountTypes=='spell'&&ite.spellText.indexOf('件')>-1&&ite.spellData.indexOf('赠')==-1">满<span style="fontSize:16px;">{{ite.spellText.match(/\d+(\.\d+)?/g)[0]}}</span>件：￥<span style="fontSize:16px;">{{ite.spellData.match(/\d+(\.\d+)?/g)[0]}}</span></span>
              <!-- 没件没赠 -->
              <span v-if="ite.discountTypes=='spell'&&ite.spellText.indexOf('件')==-1&&ite.spellData.indexOf('赠')==-1">满￥<span style="fontSize:16px;">{{ite.spellText.match(/\d+(\.\d+)?/g)[0]}}</span>：￥<span style="fontSize:16px;">{{ite.spellData.match(/\d+(\.\d+)?/g)[0]}}</span></span>
              <!-- 有件有赠 -->
              <span v-if="ite.discountTypes=='spell'&&ite.spellText.indexOf('件')>-1&&ite.spellData.indexOf('赠')>-1">满<span style="fontSize:16px;">{{ite.spellText.match(/\d+(\.\d+)?/g)[0]}}</span>件：赠￥<span style="fontSize:16px;">{{ite.spellData.match(/\d+(\.\d+)?/g)[0]}}</span></span>
              <!-- 有件 -->
              <span v-if="ite.discountTypes=='give'&&ite.giveText.indexOf('件')>-1">满<span style="fontSize:16px;">{{ite.giveText.match(/\d+(\.\d+)?/g)[0]}}</span>件：用￥<span style="fontSize:16px;">{{ite.giveData}}</span></span>
              <!-- 无件 -->
              <span v-if="ite.discountTypes=='give'&&ite.giveText.indexOf('件')==-1">满￥<span style="fontSize:16px;">{{ite.giveText}}</span>：用￥<span style="fontSize:16px;">{{ite.giveData}}</span></span>
            </div>
            <div class="rightContent">
              <span>距结束</span>
              <CountDown :endTime="ite.discountTypes?ite.endTime:($store.state.memberLevel&&ite[getMemberLevel($store.state.memberLevel).memberLevel]?ite.memberEndTime:'')"
                         @removeCon="removeCon" />
            </div>
          </div>
          <a href="javascript:;">
            <ZImage :value="ite.pictures.length?ite.pictures[0]:''"
                    :error-src="require('../../assets/image/images/default_media.png')" />
            <div class="li_hover"
                 @click.stop="$emit('emitHandleDetail',ite,'newDetail')">
              <p class="li_hover_title"
                 v-if="ite.others.length>=1">
                <span>{{ite.others[0].standardData?ite.others[0].standardData:''}}</span>
                <span>{{ite.appName?ite.appName:''}}</span>
              </p>
              <div class="li_hover_conter">
                <div class="label-box"
                     v-if="ite.others">
                  <div v-show="tag.standardName != '产品标识' && tag.standardData"
                       class="label-set"
                       v-for="(tag,tin) in ite.tags"
                       :key="tin">
                    <span>{{tag.standardName?tag.standardName+'：':''}}</span>{{allPrice(tag.standardEnName) ? formatPrice(tag.standardData) : tag.standardData}}
                  </div>
                </div>
              </div>
            </div>
          </a>
        </li>
      </ul>
      <div v-if="flowStep==3&&tabActiveType!='center'"
           class="watch clearfix">
        <div class="multistage-left fl"
             v-if="treeOragin.length">
          <el-tree :props="{label: 'name',children: 'zones',isLeaf: 'leaf'}"
                   :load="loadNode"
                   @node-click="getTree"
                   lazy>
          </el-tree>
        </div>
        <div class="black-center fl">
          <zTable v-if="table.options.length"
                  :options="table.options"
                  :optionsData="table.propsData" />
          <div v-else-if="noData"
               class="no-data"></div>
        </div>
        <div class="blue-right fl">
          <template v-if="ProjectInfo">
            <div class="version">
              <span>版本号：</span>
              <span>{{ProjectInfo.version}}</span>
            </div>
            <div class="version">
              <span>项目名称：</span>
              <span>{{ProjectInfo.professionName}}</span>
            </div>
            <div class="version">
              <span>计划数量：</span>
              <span>{{ProjectInfo.planNum}}</span>
            </div>
            <div class="version">
              <span>Cass平台名称：</span>
              <span v-if="ProjectInfo.caasPfName">
                {{ProjectInfo.caasPfName.split(',')[1]}}
              </span>
            </div>
            <div class="version">
              <span>公司名称：</span>
              <span>{{ProjectInfo.orgName}}</span>
            </div>
            <div class="version">
              <span>小组名称：</span>
              <span v-if="ProjectInfo.team">{{ProjectInfo.team.split(',')[1]}}</span>
            </div>
            <div class="version">
              <span>分管负责人：</span>
              <span v-if="ProjectInfo.projectManager&&ProjectInfo.projectManager.length">
                {{parse(ProjectInfo.projectManager)}}
              </span>
            </div>
            <div class="version">
              <span>计划开始时间：</span>
              <span>{{ProjectInfo.planStarttime}}</span>
            </div>
            <div class="version">
              <span>计划结束时间：</span>
              <span>{{ProjectInfo.planEndtime}}</span>
            </div>
            <div class="version">
              <span>完成时间：</span>
              <span>{{ProjectInfo.endTime}}</span>
            </div>
          </template>

        </div>

      </div>
      <!-- <div v-show="flowStep==1||flowStep==2||flowStep==4"
           :class="['arrow-left','arrow-left'+ swiperInd]"></div> -->
      <div v-show="flowStep==1||flowStep==2||flowStep==4"
           :class="['arrow-right','arrow-right'+ swiperInd]"
           @click="$emit('arrowRight')"></div>
    </div>
  </div>
</template>
<script>
import CountDown from "../../components/CountDown.vue";
import ZImage from "../ZImage.vue"
import zTable from "./table.vue"
export default {
  name: 'smartApp',
  components: {
    ZImage,
    zTable,
    CountDown
  },
  props: {
    blockData: {
      type: Object
    },
    centerStyle: {
      require: true,
      default: "smartApp"
    },
    listData: {
      type: Array
    },
    blockCenterList: {
      type: ''
    },
    tabActiveType: {
      type: ''
    },
    tabLeftRightLen: {
      type: ''
    },
    flowStep: {
      type: ''
    },
    swiperInd: {
      type: ''
    }
  },
  data () {
    return {
      seckillShow: true,
      timeOutEvent: 0,
      iframeSrc: '',
      mySwiper: undefined,
      // swiperInd:'',
      showLeftMenu: false,
      showRightMenu: false,
      tagsMenuPos: {
        left: 0,
        top: 0
      },
      tagsShow: false,
      tagsName: [],
      tagsValue: [],
      leftTabInd: 0,
      topTabInd: 0,
      // listData:[],
      showList: false,
      refeshflag: false,
      nodeNav: [],
      nodeNavTop: [],
      nodeNavLeft: [],
      nodeNavRight: [],
      nodeNavDown: [],
      blockId: '',
      flowId: '',
      nodeId: '',
      contentId: '',
      flowNewList: [],
      // flowStep:1,//1代表流程，2代表平台,3代表平台详情
      ProjectInfo: null,
      professionId: '',
      mainFlowJson: [
        { name: '创建业务', url: '/acnid-project-approve/scenarioinfo/bsysprofession/edit_business?professionId=' },
        { name: '选择场景', url: '/acnid-project-approve/scenarioinfo/bsysscenegroup/myscenelist?selectSceneGroupFrame=selectSceneGroupFrame&beforeProfessionId=' },
        { name: '场景商圈调整', url: '/acnid-project-approve/scenarioinfo/circlelibrary/list?groupId=iaiid-ZNKFZPT000000000000guru1601023894000156002&professionId=' },
        { name: '交付物配置', url: '/acnid-project-approve/profession/deliverable/list?groupId=iaiid-ZNKFZPT000000000000guru1601023894000156002&flag=1&professionId=' },
        { name: '时间配置', url: '/acnid-project-approve/profession/time/list?groupId=iaiid-ZNKFZPT000000000000guru1601023894000156002&flag=1&professionId=' },
        { name: '场景、交付物、考核、时间架构调整', url: '/acnid-project-approve//scenarioinfo/sdatimeframeconfig/list?groupId=iaiid-ZNKFZPT000000000000guru1601023894000156002&professionId=' },
        { name: '业务平台入库', url: '/acnid-project-approve/scenarioinfo/bsysprofession/business_platform_putIn?professionId=' }
      ],
      treeOragin: [],
      treeData: [],
      table: {
        options: []
      },
      floorTabShow: '',
      floorDetailShow: '',
      noData: false,
      preTabListTop: [],
      preTabListLeft: [],
      preTabListRight: [],
      preTabListBottom: [],
      tabTopBottomLen: 0,
      // tabLeftRightLen:0,
      // tabActiveType:'center',
      preNum: 5,
      timer: null,
      // blockCenterList:[],
      screenWidth: document.documentElement.clientWidth,//屏幕宽度
      // centerStyle:''
      standardListJson: [],
      circleTabList: [],
      canAddCircleData: true,
      candliverProp: true,
      isQuote: false,
      // centerStyles:'',
      rightContentHeight: '',
      // centerStyle:''
    }
  },
  watch: {
    floorTabShow: function (tabShow) {
      var tableft = tabShow.indexOf('left') > -1;
      var tabright = tabShow.indexOf('right') > -1;

      var tabbottom = tabShow.indexOf('down') > -1;
      var tabtop = tabShow.indexOf('up') > -1;

      // var preNum = 5;
      var Len = 0;
      var tbLen = 0;
      if (tableft || tabright) {
        Len = 1;
        // preNum = 4;
        if (tableft && tabright) {
          Len = 2;
          // preNum = 3;
        }
      }
      if (tabbottom || tabtop) {
        tbLen = 1;
        if (tabbottom && tabtop) {
          tbLen = 2;
        }
      }

      if (window.innerWidth > 425 && window.innerWidth <= 768) {
        tbLen = 0;
        Len = 0;
      }

      //    this.preNum = preNum;
      this.tabLeftRightLen = Len;
      this.tabTopBottomLen = tbLen
    },
    // screenWidth:function(){
    //     this.swiperFn();
    // }

  },
  computed: {
    isPC () {
      if (window.innerWidth > 768 ) {
        // if(window.innerWidth){
        return true;
      } else { return false; }
    },
    tagData () {
      return this.$store.state.tagData;
    }
  },
  mounted () {
    var _this = this;
    // this.swiperInd = this.blockData.sno;
    //添加 第一个主流程tab名称
    var { id, flowType, code, appId, name, pcode, floorType } = this.blockData;
    var Mainitem = { id, flowType, code, appId, name, pcode, floorType, tabType: 'main' }
    this.blockData.dataArr.unshift(Mainitem)

    // this.filterTagData2(this.blockData.dataArr);
    // // this.getFloorShowStyle(id)
    // this.getTabBlock(id);

    //tab选中 逻辑 读取上下左右中间勾选展示 默认中间，如果没有中间则按照上左右

    window.addEventListener('resize', function () {
      _this.screenWidth = document.body.offsetWidth;
    })
    // if (this.centerStyle == 'banner') {
    setTimeout(() => {
      this.swiperFn();
    }, 100)
    // }
    this.baseFloorType = this.$store.state.platFormType;
  },
  methods: {
    //判断右上角秒杀是否显示
    removeCon (ind, show) {
      this.seckillShow = show;
    },
    touchstarts (ite) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.setProfessionId(ite);
        _this.$emit('emitContextMenuItem', ite);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchstarts (ite) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.setContentId(ite);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmoves: function () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchends: function (e) {
      clearTimeout(this.timeOutEvent);
      if (this.timeOutEvent != 0) {
        // 点击事件    
        this.rightShow = false;
      }
      return false;
    },
    // 获取立项项目信息
    getProjectInfo (id) {
      this.$http
        .get("/acnid-project-approve/flowScore/info/project-flowId-list.json", {
          appId: id
        }).then(res => {
          this.treeOragin = [];
          if (res.state == 1) {
            res.data.forEach((ite) => {
              this.treeOragin.push({
                id: ite.professionId,
                appId: id,
                name: ite.professionName,
                sceneId: ite.sceneId,
                groupId: ite.groupId,
                dataType: 1
              })
            })

          }
        })
    },
    // 获取立项项目信息
    getTree (data, node) {
      this.nodeExpand(data, node);
      var id = data.id;
      this.$http
        .get("/acnid-project-approve/scenarioinfo/bsysprofession/api/info.json", {
          professionId: id,
          restrictParams: '1'
        }).then(res => {
          this.ProjectInfo = null;
          if (res.state == 1) {
            this.ProjectInfo = res.data;
          }
        })
    },
    setContentId (ite) {
      if (ite.contentId) {
        if (!window.$rightLeft) {
          window.$rightLeft = {}
        }
        window.$rightLeft.center = {
          contentId: ite.contentId,
          contentShowRowsSort: ite.contentShowRowsSort
        }
      }
    },
    setProfessionId (ite) {
      window.$professionId = ite.professionId ? ite.professionId : ite.id
    },
    loadNode (node, resolve) {
      this.noData = false;
      if (node.level === 0) {
        return resolve(this.treeOragin);
      }
      this.professionId = node.data.id;
      // this.getTree(node.data);
      if (node.data.dataType == 3) {
        this.noData = true;
        return resolve([])
      }
      this.$http
        .get("/acnid-project-approve/board/workbench/getNextDataListJson", {
          appId: node.data.appId,
          sceneId: node.data.sceneId,
          groupId: node.data.groupId,
          level: node.level
        }).then(res => {
          if (res.state == 1) {
            var item = [];
            //拼接 table参数
            var i = 0;
            var options = [{
              prop: 'cassName',
              label: "立项架构平台",
              width: "180",
              sTyle: 'red'
            }];
            var propsData = {};
            propsData.cassName = node.data.name;
            if (res.data.infoList.length == 0) {
              this.noData = true;
            }
            res.data.infoList.filter((ite) => {
              if (ite.productName) {
                item.push({
                  appId: ite.appId,
                  id: ite.professionId,
                  name: ite.productName,
                  sceneId: ite.sceneId,
                  groupId: ite.groupId,
                  dataType: ite.dataType,
                  funUrl: ite.funUrl ? `${ite.funUrl}/?appId=${ite.appId}&pfId=${ite.pfId}&flowId=${ite.flowId}` : ''
                })

                propsData['cusProductName' + i] = '';

                options.push({
                  prop: 'cusProductName' + i,
                  label: ite.productName,
                  width: "180",
                  sTyle: ite.dataType == 3 ? 'blue' : 'black'
                })

              }
            })
            this.table.propsData = [propsData];
            this.table.options = options;
            resolve(item)
          }
        })
    },
    nodeExpand (data, node) {
      this.noData = false;
      if (node.data.dataType == 3) {
        this.table.propsData = [];
        this.table.options = [];
        this.noData = true;
        return false
      }
      this.$http
        .get("/acnid-project-approve/board/workbench/getNextDataListJson", {
          appId: node.data.appId,
          sceneId: node.data.sceneId,
          groupId: node.data.groupId,
          level: node.level
        }).then(res => {
          if (res.state == 1) {
            //拼接 table参数
            var i = 0;
            var options = [{
              prop: 'cassName',
              label: "立项架构平台",
              width: "180"
            }];
            var propsData = {};
            propsData.cassName = node.data.name;
            if (res.data.infoList.length == 0) {
              this.noData = true;
            }
            res.data.infoList.filter((ite) => {
              if (ite.productName) {
                propsData['cusProductName' + i] = '';
                options.push({
                  prop: 'cusProductName' + i,
                  label: ite.productName,
                  width: "180"
                })
              }
            })
            this.table.propsData = [propsData];
            this.table.options = options;
          }
        })
    },
    //轮播图
    swiperFn () {
      let _this = this;
      _this.$nextTick(() => {
        var width = (this.$refs.rightContent.offsetWidth - 20 - (_this.preNum - 1)*20 -2) / _this.preNum;
        $('.bottom-content' + _this.swiperInd + _this.indexs + ' li').width(width);
      })
    },
    getProduct (pDataArr = []) {
      const _this = this;
      if (pDataArr.length == 0) {
        _this.setDefaultTags();
      } else {
        pDataArr.forEach((pData) => {
          var tags = [];
          var pictures = [];
          var others = [];
          var btns = [];

          if (!pData || !pData.standardJson) {

            return false;
          } else {
            if (pData.dynamicDataInter) {
              var url = pData.dynamicDataInter.substring(20);
              this.$http.get(url, { appId: '' }).then((res1) => {
                var keys = Object.keys(res1.data);
                for (var j = 0; j < keys.length; j++) {
                  pData.standardJson.forEach((ele) => {
                    if (ele.standardEnName && keys[j] === ele.standardEnName && res1.data[ele.standardEnName]) {
                      ele.standardData = res1.data[ele.standardEnName]
                    }
                  })
                }
              })
            }
            pData.standardJson.forEach((ele) => {
              // if(ele.isShow!='0'){
              if (ele.standardType == 0 && ele.standardData && (ele.standardData.indexOf('.mp4') > 0 || ele.standardData.indexOf('.png') > 0 || ele.standardData.indexOf('.jpg') > 0 || ele.standardData.indexOf('.jpeg') > 0)) {
                pictures.push(ele.standardData);
              } else if (ele.standardType == 0) {
                others.push(ele);
              } else if (ele.standardType == 3) {
                btns.push(ele);
              }

              // }
              if (ele.isShow == 1 && ele.standardType != 3) {
                tags.push(ele);
              }
            });
            this.showList = this.showList == false ? true : true;

          }
          _this.flowStep = 4;
          _this.contentId = pData.contentId;
          _this.listData.push({
            contentShowRowsSort: pData.contentShowRowsSort,
            sceneId: pData.sceneId,
            sign:pData.sign,
            contentId: pData.contentId,
            sceneGroupId: pData.sceneGroupId,
            pictures: pictures.splice(0, 4),
            others: others.splice(0, 5),
            btns: btns.splice(0, 2),
            tags: tags.splice(0, 9)
          })
        })
      }
      _this.swiperFn();
    },
    // 获取下级立项平台数据
    handleMore (item) {
      var page = 1;
      var _this = this;
      _this.flowNewList = [];
      function getFlowDataPage (page) {
        _this.$http
          .get("/zciid-deliverable/api/webapp/get/data.json", {
            //appId:this.blockData.appId,
            appId: this.getQuery('appId'),
            flowId: item.id,
            pageSize: 2,
            pageNum: page
          }).then(res => {
            if (res.state == 1 && res.data) {
              _this.flowNewList.push(...res.data);
              _this.flowStep = 1;
            } else {
              clearInterval(_this.timer);
              if (page <= 1) {
                _this.getProduct();
              }
              page = 1;
            }
          })
      }
      _this.timer = setInterval(function () {
        getFlowDataPage(page++)
      }, 300);
    },

    handleNextFlow (ite) {
      this.flowStep++;
      if (!ite.appId) {
        this.$http
          .get("/zciid-deliverable/api/webapp/get/data.json", {
            //appId:this.blockData.appId,
            appId: this.getQuery('appId'),
            professionId: ite.id,
          }).then(res => {
            if (res.state == 1) {
              this.flowNewList = res.data;
              this.swiperFn()
            }
          })
      } else {
        this.getProjectInfo(ite.appId);
      }
    }
  }
}
  </script>
  
<style scoped lang="scss">
.rightP{
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  border-radius: 0 0 0 46px;
  min-width: 130px;
  height: 46px;
  padding-left: 10px;
}
.rightSeckill {
  background: -webkit-linear-gradient(left, #ef7a41, #f33e33);
  /*  Safari 5.1 到 6.0 */
  background: -o-linear-gradient(right, #ef7a41, #f33e33);
  /*  Opera 11.6 到 12.0 */
  background: -moz-linear-gradient(right, #ef7a41, #f33e33);
  /*  Fx 3.6 到 15 */
  background: linear-gradient(to right, #ef7a41, #f33e33);
}
.rightChange{
  background: -webkit-linear-gradient(left, #ff7ccb, #f92589);
  /*  Safari 5.1 到 6.0 */
  background: -o-linear-gradient(right, #ff7ccb, #f92589);
  /*  Opera 11.6 到 12.0 */
  background: -moz-linear-gradient(right, #ff7ccb, #f92589);
  /*  Fx 3.6 到 15 */
  background: linear-gradient(to right, #ff7ccb, #f92589);
}
.rightSpell{
  background: -webkit-linear-gradient(left, #fcd071, #fc8237);
  /*  Safari 5.1 到 6.0 */
  background: -o-linear-gradient(right, #fcd071, #fc8237);
  /*  Opera 11.6 到 12.0 */
  background: -moz-linear-gradient(right, #fcd071, #fc8237);
  /*  Fx 3.6 到 15 */
  background: linear-gradient(to right, #fcd071, #fc8237);
}

.rightGive{
  background: -webkit-linear-gradient(left, #0fdee6, #1f8de9);
  /*  Safari 5.1 到 6.0 */
  background: -o-linear-gradient(right, #0fdee6, #1f8de9);
  /*  Opera 11.6 到 12.0 */
  background: -moz-linear-gradient(right, #0fdee6, #1f8de9);
  /*  Fx 3.6 到 15 */
  background: linear-gradient(to right, #0fdee6, #1f8de9);
}
.rightMemberLevel{
  background: -webkit-linear-gradient(left, #ef7a41, #f33e33);
  /*  Safari 5.1 到 6.0 */
  background: -o-linear-gradient(right, #ef7a41, #f33e33);
  /*  Opera 11.6 到 12.0 */
  background: -moz-linear-gradient(right, #ef7a41, #f33e33);
  /*  Fx 3.6 到 15 */
  background: linear-gradient(to right, #ef7a41, #f33e33);
}
.rightContent {
  line-height: 16px;
  text-align: right;
  padding: 4px 8px 0 0;
  span {
    font-size: 12px;
    color: #fff;
  }
}
.bottom-switch {
  padding: 18px 20px;
  height: 326px;
  .bottom-content {
    height: 100%;
    overflow: hidden;
    .arrow-left {
      z-index: 9;
      display: none;
      width: 22px;
      height: 48px;
      position: absolute;
      top: 50%;
      margin-top: -24px;
      left: 0;
      background: url("~@/assets/images/product_detail/recommend_arrow_left.png")
        no-repeat center;
      cursor: pointer;
    }
    .arrow-right {
      z-index: 9;
      display: none;
      width: 22px;
      height: 48px;
      position: absolute;
      top: 50%;
      margin-top: -24px;
      right: 2px;
      background: url("~@/assets/images/product_detail/recommend_arrow_right.png")
        no-repeat center;
      cursor: pointer;
    }
    &:hover {
      .arrow-left {
        display: block;
      }
      .arrow-right {
        display: block;
      }
    }
    ul {
      // overflow: hidden;
      li {
        display: block;
        font-size: 0;
        margin-right: 18px !important;
        width: 228.5px;
        height: 100%;
        // line-height: 108px;
        background: #fafafa;
        border: 1px solid#ddd;
        position: relative;
        > a {
          display: block;
          width: 100%;
          height: 100%;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .li_hover {
            transition: all 0.2s linear;
            width: calc(100% - 20px);
            // height: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            // bottom: -285px;
            background: rgba(0, 0, 0, 0.6);
            padding: 0 10px;
            .li_hover_title {
              display:flex;
              flex-direction:column;
              width: 100%;
              margin: 0;
              color: #fff;
              height: 48px;
              span{
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              span:nth-child(1){
                font-size:14px;
                color:rgb(255,255,255);
                padding-top:5px;
              }
              span:nth-child(2){
                font-size:12px;
                color:rgb(170,170,170);
                padding-top:1px;
              }
            }
            .img_right {
              color: #ffffff;
              border: 1px solid #ffffff;
              text-align: center;
              line-height: 18px;
              vertical-align: middle;
              border-radius: 50%;
              height: 18px;
              width: 18px;
              position: absolute;
              top: 10px;
              right: 10px;
              &::after {
                position: absolute;
                content: "";
                border-right: 1px solid #ffffff;
                border-top: 1px solid #ffffff;
                transform: rotate(45deg);
                height: 6px;
                width: 6px;
                top: 5px;
                left: 5px;
              }
            }
            .li_hover_conter {
              border-top: 1px dashed #bbbbbb;
              display: none;
              text-align: left;
              font-size: 14px;
              line-height: 20px;
              margin: 4px 0;
              color: #fff;
              overflow: hidden;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 7;
              height: calc(100% - 59px);
              width: 100%;
              overflow: auto;
              .label-box {
                width: 100%;
              }
              .label-set {
                height: 26px;
                line-height: 26px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
            &:hover {
              transition: all 0.2s linear;
              height: 100%;
              .li_hover_title {
                padding-top:6px;
              }
              .li_hover_conter {
                display: block;
              }
            }
          }
        }
      }
    }
    // 树形菜单
    .watch {
      width: 100%;
      max-height: 100%;
      overflow: hidden;
      line-height: 32px;
      .version {
        font-size: 14px;
        width: 100%;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .multistage-left {
        padding-right: 18px;
        width: 282px;
        height: 324px;
        overflow: auto;
      }
      .blue-right {
        padding-left: 18px;
        width: 228px;
        height: 324px;
        overflow: auto;
      }
      .blue-right .version a:hover {
        background-color: #fafafa;
      }
      .blue-right a {
        color: #2f8eed;
        display: block;
        height: 32px;
        width: 100%;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .black-center {
        padding: 0 16px;
        border-left: 1px dashed #ddd;
        border-right: 1px dashed #ddd;
        width: calc(100% - 580px);
        height: 324px;
        overflow: auto;
      }
    }
    .no-data {
      color: #999999;
      font-size: 16px;
      text-align: center;
      margin-top: 20px;
    }
    .no-data.white {
      color: #fff;
      font-size: 12px;
      text-align: left;
      margin-top: 0px;
    }
  }
  //企业简介样式
  &.companyIntroduce {
    .bottom-content {
      ul {
        li {
          border: none;
          > a {
            position: relative;
            clear: both;
            width: 100%;
            img {
              float: left;
              width: 50%;
            }
            .li_hover {
              width: calc(50% - 40px);
              background: #fff;
              float: left;
              position: static;
              padding: 0 20px;
              .li_hover_title {
                color: #333333;
              }
              .li_hover_conter {
                color: #333333;
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
  &.banner {
    .bottom-content {
      ul {
        li {
          border: none;
          > a {
            .li_hover {
              display: none;
            }
          }
        }
      }
    }
  }
}
@media screen   and (max-width: 768px) {
  .right-content .bottom-switch {
    height: 230px;
    margin-top: -10px;
  }
}
.bottom-switch.article {
  height: 232px;
}
.bottom-switch.enterprisAlliance {
  height: 232px;
}
// @media screen and (min-width:768px){
//     .slide{width:230px;margin:0;}
// }
// @media screen and (min-width:426px) and (max-width: 768px) {
//      .bottom-switch .bottom-content ul{width:100%;}
//      .bottom-switch{height:auto;margin-top:-10px;}
//     // .swiper-wrapper{display:block;width:100%!important;}
//      .bottom-switch .bottom-content ul li{width:calc(50% - 5px);width:-webkit-calc(50% - 5px); margin-top:10px;margin-right:17px!important;height:240px;overflow: hidden;}
//      .bottom-switch.companyIntroduce .bottom-content ul li{width:100%;height:240px;overflow: hidden;}
//     //  .bottom-switch .bottom-content ul li:nth-of-type(even){margin-right:0!important;}
//      .bottom-switch .bottom-content ul li > a .li_hover{bottom:-210px;}
//      .bottom-switch .bottom-content:hover .arrow-left,
//      .bottom-switch .bottom-content:hover .arrow-right{display:none;}
//      .bottom-switch .bottom-content .watch .black-center{width: 100%;padding: 0;border:none;}
//      .bottom-switch .bottom-content ul li > a .li_hover .li_hover_title{font-size:14px;height:30px;line-height:30px;}
//      .bottom-switch .bottom-content ul li > a .li_hover .img_right{line-height: 14px;height: 14px;width: 14px;top: 7px;right: 10px;}
//      .bottom-switch .bottom-content ul li > a .li_hover .img_right::after {height: 4px;width: 4px;top: 5px;left: 4px;}
//     .content-left-box,.content-right-box{width: 150px;position:absolute;top:0px;bottom:0px;z-index:9;background:#fff;border-left: 1px solid #dddddd;border-right: 1px solid #dddddd;height:auto;}
//     .content-left-box{left:0;}
//     .content-right-box{right:-1px;}
//     .block-content{position: relative;}
//     .btn-left,.btn-right{position: absolute;top:160px; width:30px;height:30px; border-radius:20px;z-index:8;background-size: contain;}
//     .btn-left{left:2px;background-image: url("~@/assets/image/images/icons/arrow_right_circular.png");  }
//     .btn-right{right:2px; background-image: url("~@/assets/image/images/icons/arrow_left_circular.png");}
//     .close-left,.close-right{position: absolute;top:10px; width:20px;height:20px; border-radius:10px;z-index:10;background-size: contain;background-image: url("~@/assets/image/images/icons/close_right_top.png")}
//     .close-left{left:120px;}
//     .close-right{right:120px;}
// }
</style>
  
  


// WEBPACK FOOTER //
// src/components/floorBlock/smartApp.vue